
class NonSignatureReasonCodeModel extends App.Models.BaseModel {
  modelUrl = 'ReasonCode';
  save = (modelData, callbacks) => {
    const baseModel = new App.Models.BaseModel();
    baseModel.modelUrl = this.modelUrl;
    const attributes = modelData.attributes || modelData; 
    baseModel.save({
      ...attributes,
      reasonCodeType: 'S',
      signature: true,
      delivery: false,
      over: false,
      shorts: false,
      damaged: false,
      pickup: false
    }, callbacks);
  }
}

App.Models.NonSignatureReasonCode = NonSignatureReasonCodeModel;

/* Collection */
class NonSignatureReasonCodeCollection extends App.Collections.BaseCollection {
  url = 'ReasonCode';
  model = App.Models.NonSignatureReasonCode;
}

App.Collections.NonSignatureReasonCodes = NonSignatureReasonCodeCollection;

/* Router */
class NonSignatureReasonCodeRouter extends App.Routers.BaseRouter {
  constructor() {
      const entityName = 'NonSignatureReasonCode';
      const model = App.Models.NonSignatureReasonCode;
      const collectionClass = App.Collections.NonSignatureReasonCodes;

      super(entityName, model, collectionClass);
  }

  batchDelete = (idsToDelete) => {
    if (idsToDelete && idsToDelete.length > 0) {
      App.Forms[this.entityName].pagination.first = 0;
      const grid = App.Forms[this.entityName].table;
      const ajax = new Monet.Ajax();
      ajax.url = `ReasonCode/BatchDelete`;
      ajax.method = "post";
      ajax.data = idsToDelete;
      ajax.success = (responseText, xhr) => {
        if (xhr.responseText === "true") {
          grid.setSelectedRows([]);
          this.updateGrid(this.getFilter(), Monet.Grid.addDataToGrid);
        } else {
          const messages = this.formatErrorMessage(responseText);
          this.showErrorExceptionOnPopupForm(messages);
        }
      };
      ajax.error = (xhr) => {
        if (xhr.responseText) {
          var response = JSON.parse(xhr.responseText);
          this.showErrorExceptionOnPopupForm(response);
        }
      };

      if (this.beforeSendBatchDeleteRequest) {
        this.beforeSendBatchDeleteRequest(ajax);
      }

      ajax.send();
    }
  }
  filterToEdit(id) {
    return { id, reasonCodeType: 'S', signature: true }
  }
  beforeList() {
    App.Forms.NonSignatureReasonCode.filterBuilder.getCriteriaChain = function() {
      const tempFilter = new Monet.UI.FilterBuilder();
      tempFilter.fields = this.fields;
      tempFilter.fieldList = this.fieldList;
      tempFilter.setEntity('NonSignatureReasonCode');
      const criteria = tempFilter.getCriteriaChain();
      criteria.criteriaChain[0].and.push({ attr: 'reasonCodeType', eq: 'S'})
      return criteria;
    };
  }

  afterCreateForm(entity, layout, crudStage) {
    const enableField = App.Forms[entity].form.fields.enabled;
    
    enableField.setMandatory(false);
    crudStage === 'new' && enableField.setValue(1);
  }
}

App.Routers.NonSignatureReasonCode = NonSignatureReasonCodeRouter;